const Logout = () => {
  return <h1>Logout Page</h1>;
};
export default Logout;
